import { fsmData } from '../../../../universal';
import { _ } from '../../../lib';
import { Alerts } from '../../component-main';
import { FormType, openFlyoutForm } from '../form';
import { getAttachmentGeneratedFilename } from './attachments';
import { FormFieldNoteTags, getFlattenedTags } from './tags';
export const editNote = (input) => {
    const rs = input.rs;
    if (!rs.props.editing) {
        Alerts.Alert({ msg: 'No tags available' });
        return;
    }
    openFlyoutForm({
        title: 'Edit Note',
        size: [480, null],
        formPrompt: 'Editing a note',
        defaultValue: () => ({
            title: input.note.Title ?? '',
            note: input.note.Note ?? '',
            tags: input.note.Tags ?? [],
            file: input.note.Attachment
                ? {
                    Checksum: input.note.Attachment.Checksum,
                    Filename: getAttachmentGeneratedFilename(input.note.Attachment),
                    Data: null,
                }
                : null,
        }),
        lblWidth: 40,
        fields: {
            title: FormFieldNoteTitle(),
            tags: FormFieldNoteTags(rs),
            note: FormFieldNoteBody(rs),
            file: FormFieldNoteAttachment(),
        },
        onSave: async (model, callback) => {
            console.log({ model });
            const results = await Promise.all([
                await saveNotePromise({
                    rs,
                    note: input.note,
                    newNote: {
                        Title: model.current.title,
                        Note: model.current.note,
                        Attachment: model.current.file?.Checksum,
                    },
                }),
                await saveTagUpdatesPromise({
                    rs,
                    note: input.note,
                    newNoteTags: model.current.tags,
                }),
            ]);
            const errors = results.filter(x => typeof x === 'string');
            if (errors.length > 0) {
                callback(errors.join(', '));
            }
            callback(true);
        },
    });
};
export const editNoteTags = (input) => {
    const rs = input.rs;
    if (!rs.props.tagging || !rs.props.tagging?.onUpdate) {
        Alerts.Alert({ msg: 'No tags available' });
        return;
    }
    openFlyoutForm({
        title: 'Edit Note Tags',
        size: [320, null],
        formPrompt: 'Editing the tags for a note',
        defaultValue: () => ({
            noteTags: input.note.Tags,
        }),
        lblWidth: 80,
        fields: {
            noteTags: FormFieldNoteTags(rs),
        },
        onSave: async (model, callback) => {
            const result = await saveTagUpdatesPromise({
                rs,
                note: input.note,
                newNoteTags: model.current.noteTags,
            });
            callback(result);
        },
    });
};
const saveNotePromise = async (input) => new Promise(resolve => {
    const currentValues = {
        title: input.note.Title,
        note: input.note.Note,
        attachment: input.note.Attachment,
    };
    const newValues = {
        title: input.newNote.Title,
        note: input.newNote.Note,
        attachment: input.newNote.Attachment,
    };
    const changedValues = _.pickBy(newValues, (value, key) => value !== currentValues[key]);
    console.log({ changedValues });
    if (Object.keys(changedValues).length === 0) {
        resolve(true);
        return;
    }
    input.rs.props.editing?.onEdit({
        noteID: input.note.ID,
        changes: changedValues,
        onComplete: successOrError => {
            resolve(successOrError);
        },
    });
});
const saveTagUpdatesPromise = async (input) => new Promise(resolve => {
    const nonEditableTags = fsmData(getFlattenedTags(input.rs), {
        filter: x => x.NonEditable,
        map: x => x.ID,
    });
    const existing = _.difference(input.note.Tags, nonEditableTags);
    const newTags = _.difference(input.newNoteTags, nonEditableTags);
    const additions = _.difference(newTags, existing);
    const deletions = _.difference(existing, newTags);
    if (additions.length === 0 && deletions.length === 0) {
        resolve(true);
        return;
    }
    input.rs.props.tagging?.onUpdate?.({
        additions: additions.map(x => ({
            noteID: input.note.ID,
            tagID: x,
        })),
        deletions: deletions.map(x => ({
            noteID: input.note.ID,
            tagID: x,
        })),
        onComplete: successOrError => {
            resolve(successOrError);
        },
    });
});
export const FormFieldNoteTitle = () => FormType.Text({
    lbl: 'Title',
    placeholder: '(Optional)...',
    maxLength: 80,
});
export const FormFieldNoteBody = (rs) => FormType.Textarea({
    lbl: 'Note',
    fullWidth: true,
    voicePrompt: rs.props.adding?.formPrompt,
    placeholder: 'Add your note here...',
    maxLength: 65535,
    rows: 8,
});
export const FormFieldNoteAttachment = () => FormType.FileUploadSingle({
    lbl: 'Attachment',
    dragText: 'Optional file attachment',
    fullWidth: true,
    height: 64,
});
//# sourceMappingURL=edit.js.map